import * as React from 'react';
import axios, { AxiosResponse } from 'axios';
import { getHeadersToken } from '../cart/CartAction';
import { getShopRefInStorage, getUserId } from '../mon-compte/MonCompteAction';
import Icons from '../mon-compte/Icons';
import {getHostApi} from "../../utils";

interface CBCheckoutProps {
  orderId:number;
}

interface CBCheckoutState {
  link: string;
}

export class CBCheckout extends React.Component<CBCheckoutProps, CBCheckoutState> {
  constructor(props: CBCheckoutProps) {
    super(props);
    this.state = {
      link : '',
    };
  }

  componentWillMount(): void {
    const customerId = getUserId();
    const url = getHostApi() + `/customers/${customerId}/orders/${this.props.orderId}/cic/create`;
    axios.get(url, {
      headers: getHeadersToken(),
      withCredentials: true
    }).then((res:AxiosResponse<any>) => {
      if (res.data.cic && res.data.cic.link) {
        this.setState({ link: res.data.cic.link });
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  _defineBgClass = () => {
    if (getShopRefInStorage() === 'DT') {
      return 'bg-red-dt';
    }
    else if (getShopRefInStorage() === 'TH') {
      return 'bg-black';
    }
    return 'bg-blue';
  }

  render() {
    return (
      <div>
        <a href={this.state.link}  target="_blank"
           className={'bold white py-1 px-2 small payButton d-flex align-items-center mx-auto w70' +
           ' w-75 justify-content-center ' + this._defineBgClass()}>
          <Icons icon="credit_card" size={16} color="white" />
          <span className="pl-1">Payer</span>
        </a>
      </div>
    );
  }
}
